import * as React from "react";
export function SvgSpacesMediumTableCertified(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M2.1 7v1H8v3H2.1v1H8v3H2.1v1H8v3.1h1V16h5v3.1h1V16h6.8v-1H15v-3h6.8v-1H15V8h6.8V7H2.1zM9 11V8h5v3H9zm0 4v-3h5v3H9z"
        fill="#b3b3b5"
      />
      <path
        d="M21 4v15H3V4h18m0-1H3c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V4c0-.6-.5-1-1-1z"
        fill="#6e6f72"
      />
      <circle cx={20.5} cy={18.5} r={3.5} fill="#4bbc91" />
      <path
        d="M22.5 17c-.2-.1-.4-.1-.6.1L20.4 19l-1.1-.8c-.2-.1-.4-.1-.5 0-.1.2-.1.5 0 .6l1.2.9c.5.4.6.3.9-.1l1.7-2.2c0-.1 0-.2-.1-.4z"
        fill="#fff"
      />
    </svg>
  );
}
